module.exports = __webpack_public_path__ + "static/img/tabela.17db450.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/produtos/spremidos-uva/tabela.png
// module id = IijU
// module chunks = 0